<template>
  <div class="message-info-card">
    <div class="info-content" @click.stop>
      <!-- Teslim Edildi -->
      <div class="status-row" v-if="messageStatus >= 2">
        <div class="status-left">
          <img src="/images/status/status2.png" class="tick-icon">
          <span class="status-label">Teslim edildi</span>
        </div>
        <span class="status-time">{{ deliveredTime }}</span>
      </div>

      <!-- Okundu -->
      <div class="status-row" v-if="messageStatus >= 3">
        <div class="status-left">
          <img src="/images/status/status3.png" class="tick-icon">
          <span class="status-label">Okundu</span>
        </div>
        <span class="status-time">{{ readTime }}</span>
      </div>

      <!-- Okunmadı -->
      <div class="status-row" v-if="messageStatus < 3">
        <div class="status-left">
          <span class="status-label-gray">Okunmadı</span>
        </div>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageInfoCard',
  props: {
    isSender: {
      type: Boolean,
      default: false
    },
    currentMessage: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      refreshKey: 0
    }
  },
  computed: {
    message() {
      return this.$store.state.display.messageInfoModal && this.$store.state.display.messageInfoModal.message || {}
    },
    isLastMessage() {
      // Mesajın son mesaj olup olmadığını kontrol et
      if (!this.currentMessage || !this.$store.state.message.messages) return false
      
      const messages = this.$store.state.message.messages
      if (messages.length === 0) return false
      
      // Son mesajın ID'si ile mevcut mesajın ID'sini karşılaştır
      return messages[messages.length - 1].MessageID === this.currentMessage.MessageID
    },

    deliveredTime() {
      // refreshKey değişikliğini tetiklemek için kullan
      this.refreshKey

      // Store'dan güncel mesajı al
      const currentMessage = this.$store.state.message.messages.find(m =>
        m.MessageID === this.message.MessageID
      ) || this.message

      // Grup mesajları için messagestatus kontrolü
      if (currentMessage.isGroup) {
        const messageStatuses = this.$store.state.messagestatus.messageStatuses.filter(ms =>
          ms.MessageID === currentMessage.MessageID && ms.Status >= 2
        )
        if (messageStatuses.length > 0) {
          const earliestDelivery = messageStatuses.reduce((earliest, current) => {
            return new Date(current.DeliverDate) < new Date(earliest.DeliverDate) ? current : earliest
          })
          return this.formatDateTimeShort(new Date(earliestDelivery.DeliverDate))
        }
      }
      // Tekil mesaj için UpdateDate kullan
      if (currentMessage.UpdateDate && currentMessage.Status >= 2) {
        const date = new Date(currentMessage.UpdateDate)
        return this.formatDateTimeShort(date)
      }
      return ''
    },
    readTime() {
      // refreshKey değişikliğini tetiklemek için kullan
      this.refreshKey

      // Store'dan güncel mesajı al
      const currentMessage = this.$store.state.message.messages.find(m =>
        m.MessageID === this.message.MessageID
      ) || this.message

      // Grup mesajları için messagestatus kontrolü
      if (currentMessage.isGroup) {
        const messageStatuses = this.$store.state.messagestatus.messageStatuses.filter(ms =>
          ms.MessageID === currentMessage.MessageID && ms.Status >= 3
        )
        if (messageStatuses.length > 0) {
          const earliestRead = messageStatuses.reduce((earliest, current) => {
            return new Date(current.SeenDate) < new Date(earliest.SeenDate) ? current : earliest
          })
          return this.formatDateTimeShort(new Date(earliestRead.SeenDate))
        }
      }
      // Tekil mesaj için varsayılan tarih
      if (currentMessage.Status >= 3) {
        // UpdateDate'i kullan (gerçek okunma zamanı)
        const readDate = new Date(currentMessage.UpdateDate || currentMessage.CreateDate)
        return this.formatDateTimeShort(readDate)
      }
      return ''
    },
    // Mesajın güncel durumunu al
    messageStatus() {
      // refreshKey değişikliğini tetiklemek için kullan
      this.refreshKey

      // Store'dan güncel mesajı al
      const currentMessage = this.$store.state.message.messages.find(m =>
        m.MessageID === this.message.MessageID
      )

      return currentMessage ? currentMessage.Status : this.message.Status
    }
  },
  methods: {
    closeModal() {
      this.$store.state.display.messageInfoModal = {
        isOpen: false,
        message: null
      }
    },
    formatDateTimeShort(date) {
      const messageDate = new Date(date)
      const today = new Date()
      const yesterday = new Date(today)
      yesterday.setDate(yesterday.getDate() - 1)
      
      // Saat formatı
      const timeStr = `${messageDate.getHours().toString().padStart(2, '0')}:${messageDate.getMinutes().toString().padStart(2, '0')}`
      
      // Bugün mü kontrol et
      if (messageDate.toDateString() === today.toDateString()) {
        return `Bugün, ${timeStr}`
      }
      
      // Dün mü kontrol et
      if (messageDate.toDateString() === yesterday.toDateString()) {
        return `Dün, ${timeStr}`
      }
      
      // Diğer günler için tam tarih
      return `${messageDate.getDate()}.${(messageDate.getMonth() + 1).toString().padStart(2, '0')}.${messageDate.getFullYear()}, ${timeStr}`
    },
    handleOutsideClick(event) {
      // Tooltip dışına tıklandığında kapat
      if (this.$el && !this.$el.contains(event.target) && 
          !event.target.closest('.messageMenuItem')) { // Menü öğesine tıklandığında tetiklenmemesi için
        this.closeModal()
      }
    }
  },
  watch: {
    // Store'daki mesajlar değiştiğinde
    '$store.state.message.messages': {
      handler(newVal, oldVal) {
        // Mevcut mesajın durumu değişti mi kontrol et
        if (this.message && this.message.MessageID) {
          const updatedMessage = newVal.find(m => m.MessageID === this.message.MessageID)
          if (updatedMessage) {
            // refreshKey'i artırarak computed property'lerin yeniden hesaplanmasını sağla
            this.refreshKey++
            // DOM güncellemesini zorla
            this.$nextTick(() => {
              this.$forceUpdate()
            })
          }
        }
      },
      deep: true
    },
    // MessageStatus store'u değişikliklerini dinle
    '$store.state.messagestatus.messageStatuses': {
      handler(newVal, oldVal) {
        // refreshKey'i artırarak computed property'lerin yeniden hesaplanmasını sağla
        this.refreshKey++
        // DOM güncellemesini zorla
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      },
      deep: true
    }
  },
  mounted() {
    // Document'e click event listener ekle
    document.addEventListener('click', this.handleOutsideClick)

    // EventBus üzerinden mesaj durumu güncellemelerini dinle
    if (this.$root.$on) {
      this.$root.$on('messageStatusUpdated', (data) => {
        if (data && data.MessageID === this.message.MessageID) {
          this.refreshKey++
          this.$forceUpdate()
        }
      })
    }

    // WebSocket mesaj durumu güncellemelerini dinle
    if (this.$root.$on) {
      this.$root.$on('messageStatusChanged', (data) => {
        if (data && data.MessageID === this.message.MessageID) {
          this.refreshKey++
          this.$forceUpdate()
        }
      })
    }
  },
  beforeDestroy() {
    // Component yok edildiğinde listener'ı kaldır
    document.removeEventListener('click', this.handleOutsideClick)

    // EventBus listener'larını kaldır
    if (this.$root.$off) {
      this.$root.$off('messageStatusUpdated')
      this.$root.$off('messageStatusChanged')
    }
  }
}
</script>

<style lang="less" scoped>
.message-info-card {
  position: relative;
  margin-right: -8px;
  z-index: 1;
}

.info-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  width: 220px;
  border: 1px solid #e0e0e0;
  position: relative;
  
  @media (max-width: 600px) {
    width: 170px;
  }
  
  // Ok için svg path kullanarak seamless birleşim
  &::after {
    content: '';
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 20px;
    background: white;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
    border-right: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  
  // Beyaz alanı kapat
  &::before {
    content: '';
    position: absolute;
    right: -1px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 18px;
    background: white;
    z-index: 2;
  }
}

.status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.status-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.tick-icon {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.status-label {
  font-size: 12px;
  color: #333;
  font-weight: 500;
  flex: 1;
}

.status-label-gray {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.status-time {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  margin-left: auto;
}


</style> 